<template>
  <form @submit.prevent="submit">
    <div class="order-operation-notes-modal modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title has-text-weight-bold">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <b-field label="Rating">
          <star-rating v-model="form.rating" :star-size="25" />
        </b-field>
        <b-field label="Notes">
          <b-input v-model="form.notes" name="notes" type="textarea" />
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">
          Cancel
        </button>
        <button
          id="create_comment"
          :class="`button is-info ${loading ? 'is-loading' : ''}`"
        >
          Submit
        </button>
      </footer>
    </div>
  </form>
</template>

<script>
import StarRating from "vue-star-rating";

export default {
  props: {
    title: {
      type: String,
      default: "Rate"
    },
    rate: {
      type: Function
    }
  },
  components: {
    StarRating
  },
  data: () => ({
    form: {
      rating: 0,
      notes: ""
    },
    loading: false
  }),
  methods: {
    async submit() {
      this.loading = true;

      try {
        if (this.rate) {
          await this.rate(this.form);
        }

        this.$buefy.toast.open({
          message: "Rating has been submitted.",
          type: "is-info",
          position: "is-top-right"
        });

        this.$emit("submit", this.form);
        this.$parent.close();
      } catch (err) {}

      this.loading = false;
    }
  }
};
</script>

<style scoped>
.modal-card-foot {
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/Rating/RatingModal.vue